export const SessionStorageNames = {
  userId: 'user-id',
};
